// src/utils/api/nowpayments.js
import API from "../api";

export async function createNowPayment({ product, email }) {
  try {
    const res = await API.post("/nowpayments/create", { product, email });
    const data = res.data;

    if (!data || data.error) {
      throw new Error(data?.message || "NOWPayments returned an unexpected response");
    }

    return data;
  } catch (err) {
    let msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to create NOWPayments payment";

    const needsLogin =
      msg.includes("Missing auth token") ||
      msg.includes("Unauthorized") ||
      msg.includes("jwt expired") ||
      msg.includes("invalid token");

    // throw a structured error the UI can act on
    const e = new Error(needsLogin ? "Please log in to continue." : msg);
    e.code = needsLogin ? "AUTH" : "NOWPAYMENTS";
    throw e;
  }
}
